import React from "react";
import {
  Shield, Coins, HeartPulse, Stethoscope, HandHeart,
  Umbrella, Briefcase, GraduationCap, Crown, Layers,
} from "lucide-react";

/**
 * Static registry mapping service slugs → icon + one-line tile subtitle.
 * The service names and full data come from GET /api/services — this file
 * only holds visual metadata that lives naturally on the frontend.
 */
export const SERVICE_META = {
  "life-insurance":     { Icon: Shield,        tile: "Term, whole, IUL — matched to your stage." },
  "annuities":          { Icon: Coins,         tile: "Accumulation and lifetime income contracts." },
  "health-insurance":   { Icon: HeartPulse,    tile: "ACA, HSAs, and small-group coverage." },
  "medicare":           { Icon: Stethoscope,   tile: "Educational — offerings coming soon." },
  "long-term-care":     { Icon: HandHeart,     tile: "Traditional and hybrid LTC planning." },
  "disability-income":  { Icon: Umbrella,      tile: "Own-occupation coverage for your paycheck." },
  "business-insurance": { Icon: Briefcase,     tile: "Buy-sell, key person, §162 executive bonus." },
  "college-planning":   { Icon: GraduationCap, tile: "529 plans and education-funding strategy." },
  "estate-planning":    { Icon: Crown,         tile: "ILITs, second-to-die, and legacy transfer." },
  "wealth-strategy":    { Icon: Layers,        tile: "The full pyramid, coordinated." },
};

export const SERVICE_ORDER = [
  "life-insurance", "annuities", "health-insurance", "medicare",
  "long-term-care", "disability-income", "business-insurance",
  "college-planning", "estate-planning", "wealth-strategy",
];

// Product → primary service umbrella. Used for "Part of: <Service>" cross-link
// on /products/:slug. If a product appears under multiple services, the entry
// here is the primary umbrella (the one linked from the product detail page).
export const PRODUCT_PRIMARY_SERVICE = {
  "term-life": "life-insurance",
  "whole-life": "life-insurance",
  "iul-accumulation": "life-insurance",
  "iul-protection": "life-insurance",
  "mortgage-protection": "life-insurance",
  "premium-financed-iul": "estate-planning",
  "annuity-accumulation": "annuities",
  "annuity-income": "annuities",
  "health-marketplace": "health-insurance",
  "medicare": "medicare",
  "ltc": "long-term-care",
  "disability-income": "disability-income",
  "key-person": "business-insurance",
  "buy-sell": "business-insurance",
  "exec-bonus-162": "business-insurance",
  "529-college": "college-planning",
  "estate-ilit": "estate-planning",
  // Phase 6C additions
  "final-expense": "life-insurance",
  "group-health": "health-insurance",
  "hsa-plan": "health-insurance",
  "medicare-part-d": "medicare",
  "dental-vision": "health-insurance",
  "short-term-medical": "health-insurance",
  "survivorship-life": "estate-planning",
  "variable-annuity": "annuities",
  "variable-universal-life": "life-insurance",
};

export const SERVICE_NAME = {
  "life-insurance": "Life Insurance",
  "annuities": "Annuities",
  "health-insurance": "Health Insurance",
  "medicare": "Medicare Planning",
  "long-term-care": "Long-Term Care Planning",
  "disability-income": "Disability Income Protection",
  "business-insurance": "Business Continuity & Owner Insurance",
  "college-planning": "College & Education Planning",
  "estate-planning": "Estate & Legacy Planning",
  "wealth-strategy": "Comprehensive Wealth Strategy",
};
